import { useEffect, useRef, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import SubscriptionPlan from './components/SubscriptionPlan';
import Portfolio from './components/Portfolio';
import Showcase from './components/Showcase';
import WhyUs from './components/WhyUs';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from './components/Footer';
import HexagonBackground from './components/HexagonBackground';
import EnquiryModal from './components/EnquiryModal';

export default function App() {
  const [showIntro, setShowIntro] = useState(true);
  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const [clickBurst, setClickBurst] = useState(null);
  const burstTimeout = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => setShowIntro(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleMove = (event) => {
      const x = (event.clientX / window.innerWidth - 0.5) * 30;
      const y = (event.clientY / window.innerHeight - 0.5) * 30;
      document.documentElement.style.setProperty('--bg-x', `${x}px`);
      document.documentElement.style.setProperty('--bg-y', `${y}px`);
    };
    window.addEventListener('mousemove', handleMove);
    return () => window.removeEventListener('mousemove', handleMove);
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      setClickBurst({ x: event.clientX, y: event.clientY, id: Date.now() });
      clearTimeout(burstTimeout.current);
      burstTimeout.current = setTimeout(() => setClickBurst(null), 700);
    };
    window.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('click', handleClick);
      clearTimeout(burstTimeout.current);
    };
  }, []);

  return (
    <div className={`app-shell ${showIntro ? 'is-booting' : 'is-ready'}`}>
      <HexagonBackground />
      {clickBurst && (
        <span
          className="click-burst"
          aria-hidden="true"
          style={{ left: clickBurst.x, top: clickBurst.y }}
        />
      )}
      {showIntro && (
        <div className="intro-overlay" aria-hidden="true">
          <div className="intro-card">
            <img className="intro-logo" src="/logo.jpg" alt="Kalakar Tech Crew" />
            <span>Welcome to Kalakar Tech Crew</span>
            <small>Loading your digital experience</small>
          </div>
        </div>
      )}
      <Navbar />
      <main>
        <Hero />
        <Services />
        <SubscriptionPlan onOpenEnquiry={() => setEnquiryOpen(true)} />
        <Portfolio />
        <Showcase />
        <WhyUs />
        <Testimonials />
        <CTA onOpenEnquiry={() => setEnquiryOpen(true)} />
      </main>
      <Footer />
      <EnquiryModal open={enquiryOpen} onClose={() => setEnquiryOpen(false)} />
    </div>
  );
}
